import { Component, OnInit } from '@angular/core';
import { ParseService } from '../../../../shared/common/parse/parse.service';
import { fuseAnimations } from '@fuse/animations';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { DatePipe } from '@angular/common';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { Observable } from 'rxjs/internal/Observable';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { Router } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { Subject } from 'rxjs';
import { DataService } from "../../../../shared/common/helper/http-service";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatDatepickerInputEvent } from '@angular/material';

@Component({
  selector: 'app-employees-tasks',
  templateUrl: './employees-tasks.component.html',
  styleUrls: ['./employees-tasks.component.scss'],
  animations: fuseAnimations,
})

export class EmployeesTasksComponent implements OnInit {

  firstname: any;
  lastname: any;
  taskDataColumns: string[] = ['action', 'title', 'projectName', 'estimatedHours', 'actualHours', 'status'];
  today = new Date()
  todayTime = new Date().setHours(0, 0, 0, 0);
  last10dates = [];
  employeeTasks = [];
  tasksList = [];
  profileId = [];
  dates = [];
  last10days = [];
  selectedTeamMembers = [];
  reportingToDD = [];
  departmentToDD = [];
  locationToDD = [];
  projectsList = [];
  filteredOptions: Observable<string[]>;
  selectedTeam = '';
  selectedDepartment = '';
  selectedLocation = '';
  selectedDesignation = '';
  selectedDate = new Date();
  selectDate: Date;
  date = '';
  selctedResource = '';
  workLists: {}[];
  totalRecords = 0;
  roleDD = [];
  rollOptions = [];
  taskList: any = [];
  currentWeek: any;
  weekDates: any;
  currentWeekNumber: any;
  lastweekdates = [];
  userName: any;
  userImage: any;
  empRole = '';
  currentUserProfileId = '';
  selectedProject = '';
  projectMembers = [];
  selectedDateValue = '';
  searchValue = '';
  screenshotDetails = {
    title: '',
    projectName: '',
    imageDetails: []
  };
  tenantId: any;
  AllocatedBacklogsHoursNew: number;
  membersTotalUnassignedTask: any[];
  searchInputChanged = new Subject();
  tenantRole: any;
  tenantDepartment: any;
  constructor(
    private parseService: ParseService,
    private taskService: DataService,
    private hardCodedValues: HardCodedValues,
    private getReportingToService: GetReportingToService,
    private dateService: DateServiceService,
    private queryInterface: QueryInterface,
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialog,
    private storageConfiguration: StorageConfiguration,
    private _lightbox: Lightbox,
    private router: Router
  ) {
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.currentUserProfileId = this.parseService.instance.User.current().get('profile').id;
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    /**
     * * Debounce search.
     */
    this.searchInputChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged())
      .subscribe(value => {
        this.getEmployeesList();
      });
  }

  async ngOnInit() {
    this.spinner.show();
     // Initialize the selectedDate to yesterday
     const yesterday = new Date();
     yesterday.setDate(yesterday.getDate() - 1);
     this.selectDate = yesterday;
    let datePipe = new DatePipe('en-US');
    this.date = datePipe.transform(new Date(), 'MMM dd');

    this.currentWeek = this.getWeekNumber(new Date());
    var currentWeekStartDate = this.getDateOfISOWeek(this.currentWeek[1] + 1, this.currentWeek[0]);
    this.currentWeekNumber = this.currentWeek[1] + 1;

    var weekstart = new Date(currentWeekStartDate);
    var weekend = new Date(weekstart);
    weekend.setDate(weekstart.getDate() + 7);
    this.getTenantRole();
    this.getTenantDepartment();
    this.weekDates = this.getDates(weekstart, weekend);
    await this.getEmployeesList();
    await this.getReportingTo();
    await this.getDepartments();
    await this.getLocations();
    await this.getDesignations();
    await this.getProjects();
  }

  getDates(d1, d2) {
    this.lastweekdates = [];
    var oneDay = 24 * 3600 * 1000;
    for (var d = [], ms = d1 * 1, last = d2 * 1; ms < last; ms += oneDay) {
      d.push(new Date(ms));
      let datePipe = new DatePipe('en-US');
      this.lastweekdates.push({
        date: datePipe.transform(new Date(ms), 'MMM dd'),
        value: new Date(ms),
        time: ms,
      });
    }
    return d;
  }

  getWeekNumber(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    let yearStart = Number(new Date(new Date().getFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    // Return array of year and week number
    return [d.getUTCFullYear(), weekNo - 1];
  }

  getDateOfISOWeek(w, y) {
    var simple = new Date(y, 0, 1 + (w - 1) * 7);
    var dow = simple.getDay();
    var ISOweekStart = simple;
    if (dow <= 4)
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    return ISOweekStart;
  }

  downloadExcel(): void {
    this.spinner.show();
    let dateToSend: string;
    
    if (this.selectDate) {
      // Convert the selected date to UTC to avoid timezone issues
      const utcDate = new Date(Date.UTC(
        this.selectDate.getFullYear(),
        this.selectDate.getMonth(),
        this.selectDate.getDate()
      ));
      dateToSend = utcDate.toISOString().split('T')[0];
      debugger
    } else {
      
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const utcYesterday = new Date(Date.UTC(
        yesterday.getFullYear(),
        yesterday.getMonth(),
        yesterday.getDate()
      ));
      dateToSend = utcYesterday.toISOString().split('T')[0];
    }

    this.taskService.downloadExcelReport(dateToSend).subscribe(
      (response: ArrayBuffer) => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        this.saveExcelFile(blob);
        this.spinner.hide();
      },
      error => {
        console.error('Error downloading Excel report:', error);
      }
    );
  }

  dateFilter = (d: Date | null): boolean => {
    const today = new Date();
    today.setHours(0,0,0,0);
    return d ? d <=today : false;
  }
  saveExcelFile(blob: Blob) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `TaskReport_${new Date().toISOString().replace(/[:.]/g, '-')}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  onDateChange(event: MatDatepickerInputEvent<Date>) {
    this.selectDate = event.value;
    console.log('Select Date:', this.selectDate);
  }


  previousWeek() {
    this.currentWeekNumber -= 1;
    var currentWeekStartDate = this.getDateOfISOWeek(this.currentWeekNumber, new Date().getFullYear());

    var weekstart = new Date(currentWeekStartDate);
    var weekend = new Date(weekstart);
    weekend.setDate(weekstart.getDate() + 7);

    this.weekDates = this.getDates(weekstart, weekend);
    this.getEmployeesList();
  }

  nextWeek() {
    this.currentWeekNumber += 1;
    var currentWeekStartDate = this.getDateOfISOWeek(this.currentWeekNumber, new Date().getFullYear());

    var weekstart = new Date(currentWeekStartDate);
    var weekend = new Date(weekstart);
    weekend.setDate(weekstart.getDate() + 7);

    this.weekDates = this.getDates(weekstart, weekend);
    this.getEmployeesList();
  }

  async getReportingTo() {
    this.reportingToDD = [];
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToDD = res;
    });
  }

  async getDepartments() {
    this.departmentToDD = [];
    await this.getReportingToService.getDepartment().then(res => {
      this.departmentToDD = res;
    });
  }

  async getLocations() {
    this.locationToDD = [];
    await this.getReportingToService.getLocation().then(res => {
      this.locationToDD = res;
    });
  }

  async getTenantRole(): Promise<void>{
     this.tenantRole = await this.getReportingToService.getTenantRole(this.tenantId);
  }

  async getTenantDepartment(): Promise<void>{
    this.tenantDepartment = await this.getReportingToService.getTenantDepartment(this.tenantId);
  }

  getDesignations() {
    let result = [];
    this.queryInterface.queryRoleAll(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleList = JSON.parse(jsonText);
        if (roleList.displayName) {
          result.push({ name: roleList.displayName, id: roleList.role.objectId });
        }
        else {
          result.push({ name: roleList.name, id: roleList.objectId });
        }
      }
      this.roleDD = result;
      this.rollOptions = this.bindDropDown(this.roleDD);
    });
  }

  async getProjects() {
    this.projectsList = [];
    let profileClass = this.parseService.instance.Object.extend('Project');
    let query = new this.parseService.instance.Query(profileClass);
    query.containedIn('projectInfo.currentStatus', ['New', 'In Progress']);
    query.equalTo('projectType', 'Project');
    query.equalTo('tenantId', this.tenantId);
    query.limit(1000);
    let res = await query.find();
    for (const element of res) {
      this.projectsList.push({
        value: element.id,
        label: element.get('projectInfo').projectName
      });
    }
    this.projectsList.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
  }

  clearFilter() {
    this.selectedTeam = '';
    this.selectedDepartment = '';
    this.selectedLocation = '';
    this.selectedDesignation = '';
    this.selectedProject = '';
    this.projectMembers = [];
    this.getEmployeesList();
  }

  async chooseTeam() {
    this.projectMembers = [];
    if (this.selectedProject != '' && this.selectedProject != 'all') {
      let profileClass = this.parseService.instance.Object.extend('ProjectMembers');
      let query = new this.parseService.instance.Query(profileClass);
      query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.selectedProject });
      query.limit(1000);
      query.include('user');
      query.include('user.profile');
      query.equalTo('status', 'Assigned');
      query.equalTo('tenantId', this.tenantId);
      let res = await query.find();
      for (const element of res) {
        this.projectMembers.push(element.get('user').get('profile').id);
      }
    }
    let datePipe = new DatePipe('en-US');
    this.date = datePipe.transform(new Date(), 'MMM dd');
    this.selectedDate = new Date();
    this.getEmployeesList();
  }

  async getEmployeesList(event?) {
    this.profileId = [];
    let department = [];
    this.selectedTeamMembers = [];
    let profileClass = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(profileClass);
    query.equalTo('isActive', true);
    query.equalTo('isLongLeave', false);
    query.ascending('firstName');
    query.include('reportingTo');
    query.include('location');
    query.include('department');
    query.include('role');
    query.include('organisation');
    query.equalTo('tenantId', this.tenantId);
    // if (this.empRole == 'Leader') {
    //   query.equalTo('reportingTo', {
    //     __type: 'Pointer',
    //     className: 'Profile', objectId: this.currentUserProfileId
    //   });
    //   this.addCurrentTeamLead(this.currentUserProfileId);
    // }
    let value = this.searchValue.charAt(0).toUpperCase() + this.searchValue.slice(1);
    if (this.searchValue != '') {
      query.startsWith('firstName', value);
    }
    if (this.selectedTeam != '' && this.selectedTeam != 'all') {
      query.equalTo('reportingTo', {
        __type: 'Pointer',
        className: 'Profile', objectId: this.selectedTeam
      });
      query.notEqualTo('objectId', this.selectedTeam);
      if (event == undefined) {
        this.addCurrentTeamLead(this.selectedTeam);
      }
      if (event != undefined) {
        if (event.pageIndex == 0) {
          this.addCurrentTeamLead(this.selectedTeam);
        }
      }
    }
    if (this.selectedDepartment != '' && this.selectedDepartment != 'all') {
      query.equalTo('department', {
        __type: 'Pointer',
        className: 'Department', objectId: this.selectedDepartment
      });
    }
    if (this.selectedLocation != '' && this.selectedLocation != 'all') {
      query.equalTo('location', {
        __type: 'Pointer',
        className: 'Location', objectId: this.selectedLocation
      });
    }
    if (this.selectedDesignation != '' && this.selectedDesignation != 'all') {
      query.equalTo('role', {
        __type: 'Pointer',
        className: '_Role', objectId: this.selectedDesignation
      });
    }
    if (this.selectedProject != '' && this.selectedProject != 'all') {
      query.containedIn('objectId', this.projectMembers);
    }
    query.withCount();
    query.limit(10);
    if (event != undefined) {
      let pageNumber = event.pageIndex + 1;
      let value = pageNumber * 10;
      let skip = value - 10;
      if (skip != undefined) {
        query.skip(skip);
      }
    }
    this.spinner.show();
    let results = await query.find();
    let data = JSON.parse(JSON.stringify(results));
    this.totalRecords = data.count;
    for (const element of data.results) {
      // let dep = await this.queryInterface.getDepartmentUser(element.department.objectId);
      // if (dep.length > 0) {
      //   department = dep[0].get('displayName') ? dep[0].get('displayName') : '';
      // }
      // else {
      //   department = element.department ? element.department.name : '';
      // }
      this.profileId.push(element.objectId);
      let image = '';
      var myObj = element.profileImageInfo;
      if (this.isEmpty(myObj)) {
        // Object is empty
        image = this.hardCodedValues.defaultProfileImg;
      } else {
        // Object is NOT empty
        image = element.profileImageInfo.url
      }
      this.selectedTeamMembers 
      this.selectedTeamMembers.push({
        profileId: element.objectId,
        name: element.firstName + ' ' + element.lastName,
        image: image,
        department: element.department.name,
        designation: element.role ? element.role.name : '',
        designationId: element.role.objectId
      });
    }
    await this.getTotalUnassignedTask();
    this.profileId.push(this.selectedTeam);
    this.getUserPlannedTasks();
    this.spinner.hide();
  }

  addCurrentTeamLead(selectedTeam) {
    var queryProfile = new this.parseService.instance.Object('Profile');
    queryProfile.id = selectedTeam;
    let image = '';
    var myObj = queryProfile.get('profileImageInfo');
    if (this.isEmpty(myObj)) {
      // Object is empty
      image = this.hardCodedValues.defaultProfileImg;
    } else {
      // Object is NOT empty
      image = queryProfile.get('profileImageInfo').url;
    }
    this.selectedTeamMembers.push({
      profileId: this.selectedTeam,
      name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
      image: image,
      department: queryProfile.get('department') ? queryProfile.get('department').get('name') : '',
      designation: queryProfile.get('role') ? queryProfile.get('role').get('name') : '',
      designationId: queryProfile.get('role').id
    });
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }
  async getTotalUnassignedTask(): Promise<void> {
    this.membersTotalUnassignedTask = [];
    for (const element of this.selectedTeamMembers) {
      let totalTask = [];
      const Task = this.parseService.instance.Object.extend('Tasks');
      const tasksQuery = new this.parseService.instance.Query(Task);
      // queryTasks.include('scrumboardList');
      // tasksQuery.equalTo('assignee', { __type: 'Pointer', className: 'Profile', objectId: profile.profileId });
      tasksQuery.contains('assigneesId', element.profileId);
      // tasksQuery.equalTo('tenantId', this.tenantId);
      tasksQuery.notEqualTo('defaultTask', true);
      tasksQuery.equalTo('isAllocated', false);
      // tasksQuery.equalTo('cardType', 'Backlog');
      const task = await tasksQuery.find();
      if (task.length > 0) {
        totalTask.push(task);
        this.membersTotalUnassignedTask.push(...totalTask[0]);
        totalTask = [];
      }

      // const Todo = this.parseService.instance.Object.extend('Todos');
      // const todoQuery = new this.parseService.instance.Query(Todo);
      // todoQuery.containedIn('assigneesId', [element.profileId]);
      // todoQuery.equalTo('tenantId', this.tenantId);
      // todoQuery.equalTo('isAllocated', false);
      // const todo = await todoQuery.find();
      // if (todo.length > 0) {
      //   totalTask.push(todo);
      //   this.membersTotalUnassignedTask.push(...totalTask[0]);
      //   totalTask = [];
      // }
    }
    this.membersTotalUnassignedTask = JSON.parse(JSON.stringify(this.membersTotalUnassignedTask));
  }

  async getUserPlannedTasks() {
    let listOfTasks = [];
    const queryInstance = this.parseService.instance.Object.extend('UserPlannedTasks');
    const query = new this.parseService.instance.Query(queryInstance);
    query.include('profileId');
    query.include('taskId');
    query.include('todoId');
    query.containedIn('profileId', this.profileId);
    query.limit(2000);
    query.greaterThan('date', this.weekDates[0]);
    query.lessThan('date', this.weekDates[6]);
    // query.equalTo('tenantId', this.tenantId);
    let results = await query.find();
    listOfTasks = results;
    let datePipe = new DatePipe('en-US');
    this.employeeTasks = [];
    for (const element of this.selectedTeamMembers) {
      this.AllocatedBacklogsHoursNew = 0;
      const backlogsData = { totalHours: 0, allocatedHours: 0 };
      // const backlogData =  await this.getUserBacklogs(element);

      /** 
       * * Remove the duplicate object from the array (if the task is assigned more than one person)
      */
      this.membersTotalUnassignedTask = this.membersTotalUnassignedTask.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.objectId === value.objectId 
        ))
      );

      const backlogData = {
        TotalBacklogsHours: this.membersTotalUnassignedTask.filter(x => x.assigneesId.includes(element.profileId)),
        AllocatedBacklogsHours: []
      };
      backlogData.TotalBacklogsHours.forEach((types) => {
        // backlogsData.totalHours += data.get('estimatedHours');
        // types.forEach( (type) => {
        // backlogsData.totalHours += types.get('estimatedHours');
        backlogsData.totalHours += types.estimatedHours;
        // });
      });
      // if( backlogData.AllocatedBacklogsHours){
      //   backlogData.AllocatedBacklogsHours.forEach( (data) => {
      //     // backlogsData.allocatedHours += backlogData.AllocatedBacklogsHours[0].get('taskId').get('estimatedHours');
      //     if (data.get('taskType') === 'Project') {
      //       if (data.get('taskId').get('defaultTask') === true ){

      //       } else {
      //         backlogsData.allocatedHours += data.get('estimatedHours');
      //       }
      //     } else {
      //     backlogsData.allocatedHours += data.get('estimatedHours');
      //     }

      //   });
      // }
      let workHours = [];
      let selectedMembers = listOfTasks.filter(x => x.get('profileId').id == element.profileId);
      for (const data of this.weekDates) {
        let filterByDate = selectedMembers.filter(x => datePipe.transform(new Date(x.get('date')), 'dd MMM yyyy') == datePipe.transform(data, 'dd MMM yyyy'));
        let actual = 0;
        let estimated = 0;
        let percentage = 0;
        let overPercentage = 0;
        // not calculating the default task actual and estimated hours
        for (const innerelement of filterByDate) {
          if (innerelement.get('taskType') === 'Project') {
            if (innerelement.get('taskId').get('defaultTask') === true) {

            }
            else {
             let webEstimated = 0;
             const webTime = innerelement.get('webTaskStartTime');
              if ( webTime !== '' && webTime !== undefined  ){
                const endTime = Date.now();
                const statTime = +webTime;
                 webEstimated = +(endTime - statTime).toFixed();
                 webEstimated = webEstimated / 1000;
              }
              // actual += innerelement.get('actualHours');
              actual += innerelement.get('actualHours') + webEstimated;
              estimated += innerelement.get('estimatedHours');
            }
          } else {
            actual += innerelement.get('actualHours');
            estimated += innerelement.get('estimatedHours');
          }
        }
        if (estimated != 0) {
          percentage = (actual / estimated) * 100;
        }
        if (percentage > 100) {
          overPercentage = percentage - 100;
        }
        this.AllocatedBacklogsHoursNew = this.AllocatedBacklogsHoursNew + estimated;
        workHours.push({
          date: data,
          dateValue: datePipe.transform((data), 'EEEEE, MMM d'),
          actual: (actual / 3600).toFixed(0),
          actualMinutes: (actual % 3600 / 60).toFixed(0),
          actualSeconds: actual,
          estimated: (estimated / 3600).toFixed(0),
          estimatedMinutes: (estimated % 3600 / 60).toFixed(0),
          estimatedSeconds: estimated,
          percentage: overPercentage
        });
      }
      // let displayName = await this.queryInterface.getRoleDisplayName(element.designationId);
      // displayName = displayName === '' ? element.designation : displayName;
      this.employeeTasks.push({
        profileId: element.profileId,
        name: element.name,
        image: element.image,
        backlogs: backlogsData,
        workHours: workHours,
        workHoursTotal: this.AllocatedBacklogsHoursNew,
        designation: this.getReportingToService.getRoleDisplayName(element.designation),
        // designation: displayName,
        department: this.getReportingToService.getDepartmentDisplayName(element.department)
      });
    }
  }
  // async getUserBacklogs(profile, callback?): Promise<any> {
  //   const data = {
  //     TotalBacklogsHours: await this.getTotalBacklogsHours(profile),
  //     // AllocatedBacklogsHours: await this.getAllocatedBacklogsHours(profile)
  //   };
  //   return await data;
  // }
  async getTotalBacklogsHours(profile): Promise<any> {
    const totalTask = [];
    const Task = this.parseService.instance.Object.extend('Tasks');
    const tasksQuery = new this.parseService.instance.Query(Task);
    // queryTasks.include('scrumboardList');
    // tasksQuery.equalTo('assignee', { __type: 'Pointer', className: 'Profile', objectId: profile.profileId });
    tasksQuery.contains('assigneesId', profile.profileId);
    tasksQuery.notEqualTo('defaultTask', true);
    tasksQuery.equalTo('isAllocated', false);
    // tasksQuery.equalTo('cardType', 'Backlog');
    const task = await tasksQuery.find();
    totalTask.push(task);
    // const Todo = this.parseService.instance.Object.extend('Todos');
    // const todoQuery = new this.parseService.instance.Query(Todo);
    // todoQuery.containedIn('assigneesId', [profile.profileId]);
    // todoQuery.equalTo('isAllocated', false);
    // const todo = await todoQuery.find();
    // totalTask.push(todo);
    return totalTask;
  }

  // backlogSecondsToHm(d) {
  //   d = Number(d);
  //   var h = Math.floor(d / 3600);
  //   var m = Math.floor(d % 3600 / 60);
  //   var s = Math.floor(d % 3600 % 60);

  //   // var hDisplay = (h <= 9 ? '0' : '') + h;
  //   var hDisplay = h;
  //   var mDisplay = (m <= 9 ? '0' : '') + m;
  //   var sDisplay = (s <= 9 ? '0' : '') + s;
  //   return hDisplay + ':' + mDisplay;
  // }

  // async getAllocatedBacklogsHours(profile): Promise<any> {
  //   let profileId = profile.profileId;
  //   let queryInstance = this.parseService.instance.Object.extend('UserPlannedTasks');
  //   let query = new this.parseService.instance.Query(queryInstance);
  //   query.include('profileId');
  //   query.include('project');
  //   query.include('taskId');
  //   query.include('todoId');
  //   query.equalTo('profileId', {
  //     __type: 'Pointer',
  //     className: 'Profile',
  //     objectId: profileId
  //   });
  //   // query.equalTo('status', 'backlog');
  //   // let dateDifferent = this.startEndDateByDate(date);
  //   query.greaterThan('date', this.weekDates[0]);
  //   query.lessThan('date', this.weekDates[6]);
  //   query.equalTo('isCloned', false);
  //   return await query.find();
  // }
  async getNotAllocatedTaskAndTodo(profile): Promise<any> {
    const taskList = [];
    this.tasksList = [];
    let tasks = await this.getTotalBacklogsHours(profile);
    tasks = JSON.parse(JSON.stringify(tasks));
    tasks.forEach(todoOrTask => {
      for (const element of todoOrTask) {
        // if (element.taskType === 'Project') {
        taskList.push({
          taskId: element.objectId,
          status: element.status ? element.status : 'Not Yet Started',
          title: element.title,
          projectName: element.Project ? element.Project.projectInfo.projectName : element.title,
          estimatedHoursInSeconds: element.estimatedHours,
          estimatedHours: this.secondsToHm(element.estimatedHours),
          actualHoursInSeconds: element.actualHours !== undefined ? element.actualHours : 0,
          actualHours: this.secondsToHms(element.actualHours !== undefined ? element.actualHours : 0),
          priority: element.taskType ? element.taskType.slice(-1)[0] : '',
          taskRole: element.taskRole,
          description: element.description,
          taskDay: element.day,
          taskDate: element.date,
          taskType: element.taskType,
          isWorkStarted: element.isWorkStarted
        });
        // }
      }
    });
    this.tasksList = taskList;

  }

  highlightRow(data, index): void {
    // console.log(data, index);
    // data.path[2].style.backgroundColor = 'red'
  }

  // async getReallocateTask(profile, date?): Promise<any> {
  //   let plannedTasks = [];
  //   let userPlannedTasks;
  //   let profileId = profile.profileId;
  //   let queryInstance = this.parseService.instance.Object.extend('UserPlannedTasks');
  //   let query = new this.parseService.instance.Query(queryInstance);
  //   query.include('profileId');
  //   query.include('project');
  //   query.include('taskId');
  //   query.include('todoId');
  //   query.equalTo('profileId', {
  //     __type: 'Pointer',
  //     className: 'Profile',
  //     objectId: profileId
  //   });
  //   query.equalTo('status', 'backlog');
  //   // let dateDifferent = this.startEndDateByDate(date);
  //   query.greaterThan('date', this.weekDates[0]);
  //   query.lessThan('date', this.weekDates[5]);
  //   query.equalTo('isCloned', false);
  //   let results = await query.find();
  //   plannedTasks = JSON.parse(JSON.stringify(results));
  //   let taskList = [];
  //   if (plannedTasks.length > 0) {
  //     for (const element of plannedTasks) {
  //       if (element.taskType == 'Project') {
  //         taskList.push({
  //           taskId: element.taskId.objectId,
  //           status: element.status,
  //           title: element.taskId.title,
  //           projectName: element.project.projectInfo.projectName,
  //           estimatedHoursInSeconds: element.estimatedHours,
  //           estimatedHours: this.secondsToHm(element.estimatedHours),
  //           actualHoursInSeconds: element.actualHours,
  //           actualHours: this.secondsToHms(element.actualHours),
  //           priority: element.taskId.taskType ? element.taskId.taskType.slice(-1)[0] : '',
  //           taskRole: element.taskId.taskRole,
  //           description: element.taskId.description,
  //           taskDay: element.day,
  //           taskDate: element.date,
  //           taskType: element.taskType,
  //           isWorkStarted: element.isWorkStarted
  //         });
  //       }
  //       if (element.taskType == 'Todo') {
  //         taskList.push({
  //           todoId: element.todoId.objectId,
  //           status: element.status,
  //           title: element.todoId.taskDetails.title,
  //           projectName: 'To do',
  //           estimatedHoursInSeconds: element.estimatedHours ? element.estimatedHours : '',
  //           estimatedHours: this.secondsToHm(element.estimatedHours ? element.estimatedHours : ''),
  //           actualHoursInSeconds: element.actualHours,
  //           actualHours: this.secondsToHms(element.actualHours),
  //           priority: element.todoId.priority ? element.todoId.priority : '',
  //           taskDay: element.day,
  //           taskDate: element.date,
  //           taskType: element.taskType,
  //           description: element.todoId.taskDetails.notes,
  //           isWorkStarted: element.isWorkStarted
  //         });
  //       }
  //     }
  //     userPlannedTasks = taskList;
  //     return userPlannedTasks;
  //   }
  //   return taskList;
  // }

  secondsToHm(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;

    return hDisplay + ':' + mDisplay;
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;

  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }

  async getTaskList(profileId, date, name, image, dateValue, type) {
    this.selctedResource = profileId;
    this.selectedDate = date;
    this.selectedDateValue = dateValue;
    this.userName = name;
    this.userImage = image
    let result = [];
    this.tasksList = [];
    const queryInstance = this.parseService.instance.Object.extend('UserPlannedTasks');
    const query = new this.parseService.instance.Query(queryInstance);
    query.include('profileId');
    query.include('taskId');
    query.include('todoId');
    query.include('project');
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: profileId });
    query.limit(2000);
    if (date) {
      let dateDifferent = this.dateService.startEndDateByDate(date);
      query.greaterThan('date', dateDifferent[0]);
      query.lessThan('date', dateDifferent[1]);
    } else {
      if (type === 'allocatedBacklogs') {
        query.greaterThan('date', this.weekDates[0]);
        query.lessThan('date', this.weekDates[5]);
      }
    }
    // query.equalTo('tenantId', this.tenantId);
    let results = await query.find();
    let previousDayResults = JSON.parse(JSON.stringify(results));
    for (const element of previousDayResults) {
      let webEstimated = 0;
       const webTime = element.webTaskStartTime;
       if ( webTime !== '' && webTime !== undefined  ){
         const endTime = Date.now();
         const statTime = +webTime;
          webEstimated = +(endTime - statTime).toFixed();
          webEstimated = webEstimated / 1000;
       }
      if (element.taskType == 'Project') {
        if (element.taskId != undefined && element.taskId.defaultTask !== true) {
          element.actualHours += webEstimated;
          result.push({
            profileId: profileId,
            taskId: element.taskId.objectId,
            status: element.status,
            title: element.taskId.title,
            cardNumber: element.taskId.cardNumber,
            projectName: element.project.projectInfo.projectName,
            // estimatedHours: this.secondsToHm(element.taskId.estimatedHours ? element.taskId.estimatedHours : ''),
            estimatedHours: this.secondsToHm(element.estimatedHours ? element.estimatedHours : ''),
            actualHours: this.secondsToHm(element.actualHours),
            // estimatedHoursInSeconds: element.taskId.estimatedHours ? element.taskId.estimatedHours : '',
            estimatedHoursInSeconds: element.estimatedHours ? element.estimatedHours : '',
            actualHoursInSeconds: element.actualHours,
            priority: element.taskId.taskType.slice(-1)[0],
            assigneesId: element.taskId.assigneesId,
            taskRole: element.taskId.taskRole,
            taskDay: element.day,
            taskType: element.taskType
          });
        }
      }
      if (element.taskType == 'Todo' || element.taskType === 'Todos') {
        if (element.taskId != undefined) {
          element.actualHours += webEstimated;
          result.push({
            profileId: profileId,
            todoId: element.taskId.objectId,
            status: element.status,
            title: element.taskId.taskDetails.title,
            cardNumber: '',
            projectName: 'To do',
            // estimatedHours: this.secondsToHm(element.taskId.estimatedHours ? element.taskId.estimatedHours : ''),\
            estimatedHours: this.secondsToHm(element.estimatedHours ? element.estimatedHours : ''),
            // actualHours: this.secondsToHm(element.taskId.estimatedHours ? element.taskId.estimatedHours : ''),
            // actualHours: this.secondsToHm(element.estimatedHours ? element.estimatedHours : ''),
            actualHours: this.secondsToHm(element.actualHours),
            priority: element.taskId.priority ? element.taskId.priority : '',
            assigneesId: element.taskId.assigneesId,
            taskDay: element.day,
            taskType: element.taskType
          });
        }
      }
    }
    this.tasksList = result;
  }

  viewProfile(events) {
    this.router.navigate(['profile-view', { id: events }]);
  }

  async getTaskScreenshots(element) {
    this.screenshotDetails = {
      title: '',
      projectName: '',
      imageDetails: []
    };
    this.screenshotDetails.title = element.title;
    this.screenshotDetails.projectName = element.projectName;
    let dateDifferent = this.dateService.startEndDateByDate(this.selectedDate);
    const queryInstance = this.parseService.instance.Object.extend('UserScreenShots');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: element.profileId });
    query.greaterThan('createdAt', dateDifferent[0]);
    query.lessThan('createdAt', dateDifferent[1]);
    let results = await query.find();
    if (results.length > 0) {
      let imageDetails = results[0].get('imageDetails');
      let imageDetailsList = [];
      if ('taskId' in element) {
        let taskList = imageDetails.filter(x => x.taskId == element.taskId);
        taskList.forEach(taskListElement => {
          let recordedTime = (new Date(taskListElement.recordedTime));
          let taskListItem: any = {};
          taskListItem.src = taskListElement.apiUrl
          taskListItem.caption = recordedTime
          taskListItem.thumb = taskListElement.apiUrl
          imageDetailsList.push(taskListItem);
        });
      }
      if ('todoId' in element) {
        let todoList = imageDetails.filter(x => x.taskId == element.todoId);
        todoList.forEach(todoListElement => {
          let recordedTime = (new Date(todoListElement.recordedTime));
          let todoListItem: any = {};
          todoListItem.src = todoListElement.apiUrl
          todoListItem.caption = recordedTime
          todoListItem.thumb = todoListElement.apiUrl
          imageDetailsList.push(todoListItem);
        });
      }
      this.screenshotDetails.imageDetails = imageDetailsList;
    }
  }

  open(index: number): void {
    this._lightbox.open(this.screenshotDetails.imageDetails, index);
  }

  close(): void {
    this._lightbox.close();
  }

}

